module.exports = __webpack_public_path__ + "static/media/spinner-white-sm.794eda5c.svg";